

export enum ReplyTypes {
    normal,
    challenge,
    
}

